import React from "react";
import {
  AlertNotification,
  H2,
  Popup,
  PopupHeader,
  SkubotSpinner,
  XIcon,
} from "@commonsku/styles";
import { BASE_ZINDEX } from "../../../popup-factory";
import styled from "styled-components";

interface PushToShopifyPopupProps {
  onClose: (popup: string) => void;
}

const StyledContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const PushToShopifyPopup = ({ onClose }: PushToShopifyPopupProps) => {
  return (
    <>
      <Popup
        overlayZIndex={BASE_ZINDEX + 100}
        zIndex={BASE_ZINDEX + 200}
        style={{ width: 575, height: 344, borderRadius: 10 }}
        header={
          <PopupHeader
            style={{ padding: 0, alignItems: "center", marginBottom: 16 }}
          >
            <H2
              style={{
                fontSize: 24,
                lineHeight: "40px",
                margin: "0px",
              }}
              className="title"
            >
              Pushing to Shopify
            </H2>
            <XIcon
              style={{ cursor: "pointer" }}
              size="large"
              onClick={() => onClose("")}
            />
          </PopupHeader>
        }
      >
        <StyledContainer>
          <AlertNotification
            alertType={"warn"}
            style={{ height: 80, alignItems: "center" }}
          >
            Your products are being pushed to Shopify. You will receive an email
            when the process is complete.
          </AlertNotification>
          <SkubotSpinner size="small" style={{ margin: "auto" }} />
        </StyledContainer>
      </Popup>
    </>
  );
};

export default PushToShopifyPopup;
